import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import StringConstants from '@common/constants/StringConstants';
import DebouncedButton from '@common/components/DebouncedButton';

interface Props {
  onConfirm: () => void;
  onBack: () => void;
  hasRentalProtectionPolicy?: boolean;
  listingAlias?: string;
}

const ConfirmStopPayments = ({ onConfirm, onBack, hasRentalProtectionPolicy, listingAlias }: Props) => (
  <Container>
    <Row>
      <Col>
        <Text type="h3">Are you sure you want to stop payments now?</Text>
        {hasRentalProtectionPolicy ? (
          <Text className="mtm">
            This lease is covered under Rental Protection. Stopping payments for this tenant may result in the denial of
            any insurance claims filed with LeaseLock. We recommend you to first cancel the RP policy from the{' '}
            <Link
              escape={false}
              target="_blank"
              to={StringConstants.LINKS.RENTAL_PROTECTION.MANAGE_POLICY_PAGE(listingAlias)}
              type="primary"
            >
              Manage Policy page.
            </Link>
          </Text>
        ) : (
          <Text>
            You will no longer receive payments. Any payments already in progress will continue to process. We&apos;ll
            notify your tenant.
          </Text>
        )}
      </Col>
    </Row>
    <Row>
      <Col>
        <DebouncedButton full type="primary" onClick={onConfirm}>
          Yes, stop payments
        </DebouncedButton>
      </Col>
    </Row>
    <Row>
      <Col>
        <Button full type="tertiary" onClick={onBack}>
          Nevermind, go back
        </Button>
      </Col>
    </Row>
  </Container>
);

export default ConfirmStopPayments;
